import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  Image,
} from "@chakra-ui/react";
import React from "react";
import rockanimal from "../../../assets/about/rockanimal.png";
import aboutbgFlipped from "../../../assets/about/aboutbg-flipped.png";
import heroIcon from "../../../assets/home/paji3.png"; // 🔁 <-- Add your image here

const Hero = ({
  heading = "From the Land of Royals to",
  subHeading = "The World of Digital Royals",
  flippedBG = false,
}) => {
  return (
    <>
      <Box
        position="relative"
        overflow="hidden"
        bgImage={`url(${flippedBG ? aboutbgFlipped : ''}) `|| ''}
        left={"0"}
        bottom={`0`}
        bgSize="cover"
        bgColor={"#005770"}
        bgPosition="center"
        height="61vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        {/* <Box position="absolute" top="0" left="0" width="100%" height="100%" /> */}
        <Image src={flippedBG ? aboutbgFlipped : rockanimal} bottom={"0"} width={'50%'} position="absolute" left={"0"} />
        <Container maxW="container.xl" position="relative" zIndex="1">
          <VStack spacing={4} textAlign="center" color="white" pt="80px">
            {/* ⬇️ Add Image + Text Side by Side */}
            <HStack spacing={3} justify="center">
              <Text
                fontSize={{ base: "xl", md: "2xl" }}
                fontWeight="bold"
                color="black"
              >
                {heading}
              </Text>
              <Image
                src={heroIcon}
                alt="Hero Icon"
                boxSize={{ base: "30px", md: "40px" }}
              />
            </HStack>

            <Heading
              fontSize={{ base: "2xl", md: "4xl" }}
              fontWeight="extrabold"
              color="white"
            >
              {subHeading}
            </Heading>
          </VStack>
        </Container>
      </Box>
    </>
  );
};

export default Hero;
